

export default {
    data (){
        return {
            selectedLang: "en",

            langText: {
                en: {
                    banner_title_1: "OCBC",
                    banner_title_2: "MyWellness Fiesta 2026",
                    banner_title_3: "A new frontier",
                    view_more: "View More",
                    footer: "© Copyright 2026 – OCBC. All Rights Reserved."
                },
                cn: {
                    banner_title_1: "华侨银行",
                    banner_title_2: "2026健康嘉年华",
                    banner_title_3: "一个崭新的疆域",
                    view_more: "查看更多",
                    footer: "© 版权所有 2026 – 华侨银行。保留所有权利"
                }
            }
        }
    },
    computed: {
    	
    },
    mounted(){
        
    },
    methods: {
        scrollToContent(){
            const element = document.getElementById("auth_content");
            element.scrollIntoView({ behavior: "smooth" });
        },
        onChangeSelectedLang(item){
            this.selectedLang = item;
        }
    },
    watch: {
        
    }
}
